import { faker } from "@faker-js/faker";

import type { 
  ParseCSVInBucketResponse, 
  ProductQualityMetric,
  MetaField 
} from '../types/api';

export const generateMockProducts = (count: number = 10): ProductQualityMetric[] => {
  return Array.from({ length: count }, (): any => ({
    product_id: faker.string.uuid(),
    variant_id: faker.string.uuid(),
    quality_score: faker.number.float({ min: 0, max: 1, precision: 0.01 }),
    // actions: Array.from({ length: faker.number.int({ min: 1, max: 4 }) }, () => ({
    //   id: faker.string.uuid(),
    //   name: faker.helpers.arrayElement([
    //     'Improve Description',
    //     'Add More Images',
    //     'Optimize SEO',
    //     'Add Missing Tags'
    //   ]),
    //   description: faker.lorem.sentence(),
    //   status: faker.helpers.arrayElement(['recommended', 'valid', 'unsupported'])
    // })),
    title: faker.commerce.productName(),
    variant_title: faker.commerce.productName(),
    category_full_name: faker.commerce.department(),
    category_id: faker.string.uuid(),
    category_name: faker.commerce.department(),
    description: faker.commerce.productDescription(),
    images: Array.from(
      { length: faker.number.int({ min: 0, max: 4 }) },
      () => faker.image.url()
    ),
    tags: faker.commerce.department(),
    created_at: faker.date.recent().toISOString(),
    title_keyword_score: 0,
    title_length_score: 0,
    total_title_score: 0,
    total_desc_score: 0,
  }));
};

export const generateMockMetaFields = (count: number = 5): MetaField[] => {
  return Array.from({ length: count }, (): MetaField => ({
    name: faker.helpers.arrayElement([
      'Color',
      'Size',
      'Material',
      'Brand',
      'Collection',
      'Season'
    ]),
    id: faker.string.uuid(),
    category_id: faker.string.uuid(),
    category_name: faker.commerce.department(),
    data_source: faker.helpers.arrayElement(['user', 'glov', 'shop']),
    custom_prompt: faker.datatype.boolean() ? faker.lorem.sentence() : undefined
  }));
};

export const generateMockParseCSVResponse = (): ParseCSVInBucketResponse => {
  const fieldNames = [
    'title',
    'description',
    'price',
    'sku',
    'inventory',
    'category'
  ];

  return {
    source_paths: fieldNames.map(field => ({
      target: field,
      source: faker.datatype.boolean() 
        ? field 
        : [field, `${field}_variant`]
    })),
    examples: {
      'example1': fieldNames.map(() => faker.commerce.productName()),
      'example2': fieldNames.map(() => faker.commerce.productName())
    },
    schema_names: Object.fromEntries(
      fieldNames.map(field => [
        field,
        {
          title: field.charAt(0).toUpperCase() + field.slice(1),
          description: faker.lorem.sentence()
        }
      ])
    ),
    field_requirements: Object.fromEntries(
      fieldNames.map(field => [field, faker.datatype.boolean()])
    )
  };
};